// extracted by mini-css-extract-plugin
module.exports = {"photoPost":"UserPhotoPost_photoPost__1y-wL","file":"UserPhotoPost_file__o3rRo","preview":"UserPhotoPost_preview__2vZAl","modal":"UserPhotoPost_modal__3Oift"};